module.exports = __webpack_public_path__ + "45231f0c90747b4e26e3fe480929c56a.svg";